import script from "./DisenosTabla.vue?vue&type=script&setup=true&lang=js"
export * from "./DisenosTabla.vue?vue&type=script&setup=true&lang=js"

import "./DisenosTabla.vue?vue&type=style&index=0&id=2a483d20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a483d20"]])

export default __exports__